import {
    GET_CASE_ID_FORM, SET_CASE_ID_FORM, GET_CLOSE_CONTACT, SET_CLOSE_CONTACT, SET_SAVE_NOT_CLOSED, GET_SAVE_NOT_CLOSED, GET_CONTACT, GET_POSITION,
    SET_CONTACT, SET_POSITION
} from './ctlWebFormAction';
const initialState = {
    caseIdDetails: {},
    closeContact: {},
    saveNotClosed: {},
    getContact: {},
    getPosition: {},
};
const ctlWebForm = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASE_ID_FORM:
            return Object.assign({}, state, {
                caseIdDetails: action.value
            })
        case SET_CASE_ID_FORM:
            return Object.assign({}, state, {
                caseIdDetails: action.value
            })
        case GET_CLOSE_CONTACT:
            return Object.assign({}, state, {
                closeContact: action.value
            })
        case SET_CLOSE_CONTACT:
            return Object.assign({}, state, {
                closeContact: action.value
            })
        case GET_SAVE_NOT_CLOSED:
            return Object.assign({}, state, {
                saveNotClosed: action.value
            })
        case SET_SAVE_NOT_CLOSED:
            return Object.assign({}, state, {
                saveNotClosed: action.value
            })
        case GET_CONTACT:
            return Object.assign({}, state, {
                getContact: action.value
            })
        case GET_POSITION:
            return Object.assign({}, state, {
                getPosition: action.value
            })
        case SET_CONTACT:
            return Object.assign({}, state, {
                getContact: action.value
            })
        case SET_POSITION:
            return Object.assign({}, state, {
                getPosition: action.value
            })
        default:
            return state;
    }
}
export default ctlWebForm